import { IInitialState } from "./types";

export const initialState: IInitialState = {
  auditDocument: {
    all: {
      params: {
        page: 1,
        pageSize: 10,
        orderBy: "timestamp",
        direction: 0,
        searchTerm: null,
        dateFrom: null,
        dateTo: null,
      },
      response: {
        data: null,
        loading: false,
        error: null,
      },
    },

    pwd: {
      params: {
        page: 1,
        pageSize: 10,
        orderBy: "timestamp",
        direction: 0,
        dateFrom: null,
        dateTo: null,
        searchTerm: null,
      },
      response: {
        data: null,
        loading: false,
        error: null,
      },
    },

    archived: {
      params: {
        page: 1,
        pageSize: 10,
        orderBy: "timestamp",
        direction: 0,
        searchTerm: null,
        dateFrom: null,
        dateTo: null,
      },
      response: {
        data: null,
        loading: false,
        error: null,
      },
    },
  },
  deleteAuditDocument: {
    data: null,
    loading: false,
    error: null,
  },
  postAuditDocumentMarkAsRead: {
    data: null,
    loading: false,
    error: null,
  },
};
